<template>
  <div class="wrapper">
    <inline-field-actions :schema="schema"></inline-field-actions>
    <div class="listbox form-control inline-fields" :disabled="disabled">
      <div class="list-row list-row--full" v-for="item in items">
        <label class="input">
          {{ getItemName(item) }}
          <input type="text" :id="getItemValue(item)" :name="schema.inputName" :value="getItemValue(item)" class="form-control" :disabled="disabled" @change="onChanged($event, item)">
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { abstractField } from 'vue-form-generator';
  import { mapMutations } from 'vuex';

  export default {
    /* eslint-disable no-throw-literal */
    /* eslint-disable max-len */

    mixins: [abstractField],

    data() {
      return {
        comboExpanded: false,
      };
    },

    computed: {
      items() {
        const values = this.schema.values;
        if (typeof (values) === 'function') {
          return values.apply(this, [this.model, this.schema]);
        } return values;
      },
    },

    methods: {
      ...mapMutations('admin', [
        'setFormChanged',
      ]),

      getItemId(item) {
        if (item) {
          if (typeof this.schema.inputOptions !== 'undefined' && typeof this.schema.inputOptions.id !== 'undefined') {
            return item[this.schema.inputOptions.id];
          }
          if (typeof item.id !== 'undefined') {
            return item.id;
          }
          throw '`id` is not defined. If you want to use another key name, add a `id` property under `checklistOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/checklist.html#checklist-field-with-object-values';
        } else {
          return item;
        }
      },

      getItemValue(item) {
        if (item) {
          if (typeof this.schema.inputOptions !== 'undefined' && typeof this.schema.inputOptions.value !== 'undefined') {
            return item[this.schema.inputOptions.value];
          }
          if (typeof item.value !== 'undefined') {
            return this.value && this.value[this.getItemId(item)].value;
          }
          throw '`value` is not defined. If you want to use another key name, add a `value` property under `checklistOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/checklist.html#checklist-field-with-object-values';
        } else {
          return item;
        }
      },

      getItemName(item) {
        if (item) {
          if (typeof this.schema.inputOptions !== 'undefined' && typeof this.schema.inputOptions.name !== 'undefined') {
            return item[this.schema.inputOptions.name];
          }
          if (typeof item.name !== 'undefined') {
            return item.name;
          }
          throw '`name` is not defined. If you want to use another key name, add a `name` property under `checklistOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/checklist.html#checklist-field-with-object-values';
        } else {
          return item;
        }
      },

      onChanged(event, item) {
        if (!this.value || typeof this.value !== 'object') {
          this.value = {};
        }
        this.$set(this.value, this.getItemId(item), { name: this.getItemName(item), value: event.target.value });
        this.setFormChanged(true);
      },
    },
  };
</script>
